export default __webpack_public_path__ + "static/media/Vector.102b8657.svg";